import { Component } from '@angular/core';

@Component({
  selector: 'wchfs-nav-up-list',
  templateUrl: './nav-up-list.component.html',
  styleUrls: ['./nav-up-list.component.scss'],
})
export class NavUpListComponent {}
